<div id="template-header-container">
  <div id="template-header" [ngClass]="{'header-hide':isHide}">

    <!-- What you want -->
    <div id="left-part">
      <ng-content select=[left]></ng-content>
    </div>

    <!-- What you want -->
    <div id="middle-part">
      <ng-content select=[middle]></ng-content>
    </div>

    <!-- What you want -->
    <div id="right-part">
      <ng-content select=[right]></ng-content>
    </div>

  </div>
</div>
